// Gráficos de barras "hechos a mano" (divs con altura/ancho porcentual),
// igual técnica que src/components/dashboard/VentasCobrosGastos.js — el
// proyecto no trae ninguna librería de gráficos, así que se reutiliza el
// mismo patrón ya validado en vez de instalar una nueva dependencia.

// Barras verticales para series temporales / día de semana. `datos`:
// [{ etiqueta, valor, detalle? }]. Scroll horizontal interno en mobile
// (nunca overflow de toda la página): ver contenedor con overflow-x-auto.
export function GraficoBarrasVerticales({ datos, formatearValor, color = 'bg-emerald-500' }) {
  const maximo = Math.max(0, ...datos.map((d) => d.valor))

  if (datos.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-slate-400">
        Sin datos para el período seleccionado.
      </p>
    )
  }

  return (
    <div className="overflow-x-auto">
      <div className="flex h-48 min-w-full items-end gap-2 px-1" style={{ minWidth: `${datos.length * 36}px` }}>
        {datos.map((dato, indice) => {
          const porcentaje = maximo > 0 ? (dato.valor / maximo) * 100 : 0

          return (
            <div
              key={`${dato.etiqueta}-${indice}`}
              className="flex h-full flex-1 flex-col items-center justify-end gap-1.5"
            >
              <div
                title={`${dato.etiqueta}: ${formatearValor(dato.valor)}`}
                className={`w-full rounded-t-md ${color}`}
                style={{ height: `${porcentaje}%`, minHeight: dato.valor > 0 ? '2px' : 0 }}
              />

              <span className="whitespace-nowrap text-[10px] font-semibold text-slate-500">
                {dato.etiqueta}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

// Ranking horizontal (top productos/clientes/medios de pago/distribución
// de ticket): barra proporcional al máximo + valor a la derecha.
export function GraficoRankingHorizontal({ datos, formatearValor, color = 'bg-emerald-500' }) {
  const maximo = Math.max(0, ...datos.map((d) => d.valor))

  if (datos.length === 0) {
    return (
      <p className="py-6 text-center text-sm text-slate-400">
        Sin datos para el período seleccionado.
      </p>
    )
  }

  return (
    <div className="space-y-3">
      {datos.map((dato, indice) => {
        const porcentaje = maximo > 0 ? (dato.valor / maximo) * 100 : 0

        return (
          <div key={`${dato.etiqueta}-${indice}`}>
            <div className="mb-1 flex items-center justify-between gap-2 text-xs">
              <span className="truncate font-semibold text-slate-700">
                {indice + 1}. {dato.etiqueta}
              </span>

              <span className="shrink-0 font-semibold text-slate-900">
                {formatearValor(dato.valor)}
              </span>
            </div>

            <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100">
              <div
                className={`h-full rounded-full ${color}`}
                style={{ width: `${Math.max(porcentaje, 2)}%` }}
              />
            </div>

            {dato.subetiqueta && (
              <p className="mt-0.5 text-[11px] text-slate-400">{dato.subetiqueta}</p>
            )}
          </div>
        )
      })}
    </div>
  )
}
